<template>
  <div class="row">
    <div class="panel bg-transparent columns large-8 medium-12 large-centered text-center">
      <div
        v-if="componentReady"
        class="text-left">
        <div class="row">
          <div class="columns large-6 medium-12">
            <table style="width: 100%;">
              <tr>
                <td>
                  <h6
                    style="display: inline;"
                    v-text="t('forms.login_cred.IC_0010')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('admin')"
                  />
                </td>
              </tr>
              <tr>
                <td class="indent">
                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0001')"/>
                    <span v-text="displayData.adminInfo.Firstname"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0002')"/>
                    <span v-text="displayData.adminInfo.Lastname"/>
                  </label>

                  <label style="color: lightgrey;">
                    <strong v-text="t('include.DBcontrol.IC_0038')"/>
                    <span v-text="displayData.adminInfo.Email"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0005')"/>
                    <span v-text="displayData.adminInfo.Tel"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0008')"/>
                    <span v-text="displayData.adminInfo.Street"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0009')"/>
                    <span v-text="displayData.adminInfo.City"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0010')"/>
                    <span v-text="displayData.adminInfo.Province"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0011')"/>
                    <span v-text="displayData.adminInfo.Country"/>
                  </label>

                  <label>
                    <strong v-text="`Postal Code/Zipcode`"/>
                    <span v-text="displayData.adminInfo.Postal"/>
                  </label>
                </td>
              </tr>
            </table>
          </div>
          <div class="columns large-6 medium-12">
            <table style="width: 100%;">
              <tr>
                <td class="text-center">
                  <h6
                    style="display: inline;"
                    v-text="t('forms.company_edit.IC_0001')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('company')"
                  />
                </td>
              </tr>
              <tr>
                <td class="indent">
                  <label style="color: lightgrey;">
                    <strong v-text="t('forms.new_contractor_company.IC_0032')"/>
                    <span v-text="displayData.memberInfo.Name"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_company.IC_0042')"/>
                    <span v-text="displayData.memberInfo.OperatingAs"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_company.IC_0033')"/>
                    <span v-text="displayData.memberInfo.Street"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_company.IC_0034')"/>
                    <span v-text="displayData.memberInfo.City"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0010')"/>
                    <span v-text="displayData.memberInfo.Province"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_contact.IC_0011')"/>
                    <span v-text="displayData.memberInfo.Country"/>
                  </label>

                  <label >
                    <strong v-text="`Postal Code/Zipcode`"/>
                    <span v-text="displayData.memberInfo.Postal"/>
                  </label>

                  <label>
                    <strong v-text="t('forms.new_contractor_company.IC_0038')"/>
                    <span v-text="displayData.memberInfo.MainTel"/>
                  </label>

                  <label v-if="displayData.memberInfo.GST">
                    <strong v-text="t('member_basic_edit.IC_0073')"/>
                    <span v-text="displayData.memberInfo.GST"/>
                  </label>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">

          <div class="columns large-6 medium-12">
            <table style="width: 100%;">
              <tr>
                <td>
                  <h6
                    style="display: inline;"
                    v-text="t('directory_edit2.IC_0004')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('services')"
                  />
                </td>
              </tr>
              <tr>
                <td class="indent">
                  <ul>
                    <li
                      v-for="service in displayData.memberServices"
                      v-text="service.Text"/>
                  </ul>
                </td>
              </tr>
            </table>
          </div>

          <div class="columns large-6 medium-12">
            <table style="width: 100%;">
              <tr>
                <td>
                  <h6
                    style="display: inline;"
                    v-text="t('forms.new_contractor_jurs.IC_0001')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('jurs')"
                  />
                </td>
              </tr>
              <tr>
                <td class="indent">
                  <ul>
                    <li
                      v-for="jurs in displayData.memberJurs"
                      v-text="jurs.name"/>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div
          class="row"
          data-equalizer>
          <div
            class="columns large-6 medium-12"
            data-equalizer-watch>
            <table style="width: 100%;">
              <tr>
                <td>
                  <h6
                    class="uppercase"
                    style="display: inline;"
                    v-text="t('forms.new_contractor_numemployees.IC_0000')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('peak')"
                  />
                </td>
              </tr>
              <tr>
                <td
                  class="indent"
                  v-text="peakNumber" />
              </tr>
            </table>
          </div>
          <div
            v-if="showSubset"
            class="columns large-6 medium-12"
            data-equalizer-watch>
            <table style="width: 100%;">
              <tr>
                <td>
                  <h6
                    style="display: inline;"
                    v-text="t('xajax.newcontractor.server.IC_0063')"/>
                  <a
                    class="fa-edit fa fa-fw fa-lg float-button"
                    @click="openModal('subsets')"
                  />
                </td>
              </tr>
              <tr>
                <td class="indent">
                  <div v-for="subsets in subsetInfo.availableSubsets">
                    <strong v-text="`${subsets.Name} (${subsets.Title})`"/>
                    <ul>
                      <li
                        v-for="subsetName in filterSelectedSubset(subsets.Subsets)"
                        v-text="subsetName.Name"/>
                    </ul>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="columns large-4">
            &nbsp;
          </div>
          <div class="columns large-4">
            <button
              class="tiny radius expand"
              @click="completeRegistration"
              v-text="t('register.payment')"/>
          </div>
          <div class="columns large-4">
            &nbsp;
          </div>
        </div>

        <div class="row">
          <div class="columns">
            <div class="text-center">

            </div>
          </div>
        </div>
      </div>

      <div v-if="!componentReady">
        <i class="fa fa-spinner fa-spin fa-2x"/>
      </div>

      <modal
        v-if="showModal"
        :size="`medium`"
        :show-close-button="true"
        @close="showModal = false">
        <component
          :is="modalComponent"
          :ge-member-ids="geMemberIds"
          @complete="updateComplete"
        />
      </modal>

      <modal
        class="ge-notification-modal"
        v-if="showGeNotice"
        :size="`medium`"
        :show-close-button="true"
        @close="showGeNotice = false">
        <div class="row">
          <div class="medium-4 columns">
            <img :src="geImg" class="ge-notice-icon" />
          </div>
          <div class="medium-8 text-left columns ge-notice-text">
            <p class="highlighter emphasis" v-text="t('register.ge_review_title')"></p>
            <p>
              <h5 v-text="t('register.ge_review_upgrade')"></h5>
              <span class="ge-note" v-text="t('register.ge_review_upgrade_info')"></span>
            </p>
            <p>
              <h5 v-text="t('register.ge_review_reminder')"></h5>
              <span class="ge-note" v-text="t('register.ge_review_reminder_info')"></span>
            </p>
            <p class="no-margin">
              <button class="tiny" @click="showGeNotice = false" v-text="t('templates.page.IC_0001')"></button>
            </p>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import $                     from 'jquery';
import _                     from 'lodash';
import Modal                 from '../Ui/Modal.vue';
import CompanyContact        from './ReviewModals/CompanyContact.vue';
import CompanyServices       from './ReviewModals/CompanyServices.vue';
import CompanyJurisdications from './ReviewModals/CompanyJurisdications.vue';
import AdminContact          from './ReviewModals/AdminContact.vue';
import CompanyEmployees      from './ReviewModals/CompanyEmployees.vue';
import CompanySubset         from './ReviewModals/CompanySubset.vue';
import geImg                 from './ge.png';


export default {
  props: ['geContractor', 'geMemberIds'],

  components: {
    CompanyContact,
    CompanyServices,
    AdminContact,
    CompanyJurisdications,
    CompanyEmployees,
    CompanySubset,
    Modal,
  },

  data() {
    return {
      componentReady: false,
      displayData: {},
      showModal: false,
      modalComponent: '',
      subsetInfo: {},
      showSubset: false,
      geImg: geImg,
      showGeNotice: false,
    };
  },

  computed: {
    peakNumber() {
      switch (Number(this.displayData.memberInfo.NumEmpl)) {
        case 0:
          return t('forms.new_contractor_numemployees.IC_0008');
        case 1:
          return t('forms.new_contractor_numemployees.IC_0003');
        case 2:
          return t('forms.new_contractor_numemployees.IC_0004');
        case 3:
          return t('forms.new_contractor_numemployees.IC_0005');
        case 4:
          return t('forms.new_contractor_numemployees.IC_0006');
        case 5:
          return t('forms.new_contractor_numemployees.IC_0007');
        case 6:
          return t('forms.new_contractor_numemployees2.IC_0003');
        case 7:
          return t('forms.new_contractor_numemployees2.IC_0004');
        case 8:
          return t('forms.new_contractor_numemployees2.IC_0005');
        case 9:
          return t('forms.new_contractor_numemployees2.IC_0006');
        case 10:
          return t('forms.new_contractor_numemployees2.IC_0007');
        case 11:
          return t('forms.new_contractor_numemployees2.IC_0008');
        case 12:
          return t('forms.new_contractor_numemployees2.IC_0009');
        case 13:
          return t('forms.new_contractor_numemployees2.IC_0010');
        case 14:
          return t('forms.offices_employees_choice.MemberType100');
        case 15:
          return t('forms.offices_employees_choice.MemberType101');
        case 16:
          return t('forms.offices_employees_choice.MemberType102');
        case 17:
          return t('forms.offices_employees_choice.MemberType103');
        case 18:
          return t('forms.offices_employees_choice.MemberType104');
        case 19:
          return t('forms.offices_employees_choice.MemberType105');
        case 20:
          return t('forms.offices_employees_choice.MemberType106');
        case 21:
          return t('forms.offices_employees_choice.MemberType107');
        case 22:
          return t('forms.offices_employees_choice.MemberType108');
        case 23:
          return t('forms.offices_employees_choice.MemberType109');
        case 24:
          return t('forms.offices_employees_choice.MemberType110');
        default:
          return '';
      }
    },
  },

  activated() {
    $.post('/register/tab-data/company', (data) => {
      this.displayData = data;
      this.componentReady = true;
    }).fail( () => {
      window.location.href = '/register';
    });

    $.post('/register/tab-data/subset', (data) => {
      this.subsetInfo = data;
      this.showSubset = this.subsetInfo.availableSubsets.length !== 0;
    }).fail( () => {
      window.location.href = '/register';
    });
  },

  mounted() {
    $(document).foundation('equalizer', 'reflow');

    if (this.geContractor) {
      this.showGeNotice = true;
    }
  },

  methods: {
    filterSelectedSubset(subsetList) {
      return _.filter(subsetList, ({ Selected }) => Selected);
    },

    completeRegistration() {
      $.post('/register/complete', (url) => {
        window.location.replace(`/${url}`);
      });
    },

    openModal(type) {
      switch (type) {
        case 'admin':
          this.modalComponent = 'admin-contact';
          break;
        case 'company':
          this.modalComponent = 'company-contact';
          break;
        case 'services':
          this.modalComponent = 'company-services';
          break;
        case 'jurs':
          this.modalComponent = 'company-jurisdications';
          break;
        case 'peak':
          this.modalComponent = 'company-employees';
          break;
        case 'subsets':
          this.modalComponent = 'company-subset';
          break;
        default:
          return false;
      }

      this.showModal = true;

      return false;
    },

    updateComplete() {
      this.showModal = false;
      this.componentReady = false;

      $.post('/register/tab-data/company', (data) => {
        this.displayData = data;
        this.componentReady = true;
      }).fail( () => {
        window.location.href = '/register';
      });

      $.post('/register/tab-data/subset', (data) => {
        this.subsetInfo = data;
        this.showSubset = this.subsetInfo.availableSubsets.length !== 0;
      }).fail( () => {
        window.location.href = '/register';
      });
    },
  },
};
</script>
<style scoped>
label {
  cursor: default;
}

.float-button {
  cursor: pointer;
  float: right;
}

.indent label {
  margin-left: 30px;
  margin-bottom: 10px;
}

.uppercase {
  text-transform: capitalize;
}

.ge-notice-text .emphasis {
  font-size: 1.25em !important;
}

.ge-notice-text .highlighter {
  background-color: #FFFF00
}
</style>
